/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ShowSMSCodeMutationVariables = {
    mobile: string;
};
export type ShowSMSCodeMutationResponse = {
    readonly showSmsCode: {
        readonly result: {
            readonly code: string;
            readonly whenExpires: string;
        } | null;
    } | null;
};
export type ShowSMSCodeMutation = {
    readonly response: ShowSMSCodeMutationResponse;
    readonly variables: ShowSMSCodeMutationVariables;
};



/*
mutation ShowSMSCodeMutation(
  $mobile: String!
) {
  showSmsCode(mobile: $mobile) {
    result {
      code
      whenExpires
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobile"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mobile",
        "variableName": "mobile"
      }
    ],
    "concreteType": "ShowSMSCode",
    "kind": "LinkedField",
    "name": "showSmsCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SMSCode",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "whenExpires",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShowSMSCodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShowSMSCodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8898bcf5dc4f70461b1b138df1dbe50d",
    "id": null,
    "metadata": {},
    "name": "ShowSMSCodeMutation",
    "operationKind": "mutation",
    "text": "mutation ShowSMSCodeMutation(\n  $mobile: String!\n) {\n  showSmsCode(mobile: $mobile) {\n    result {\n      code\n      whenExpires\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '95cc2fd5ab7d51fb1fabc29325582be0';
export default node;
